/** Containers in the demo's guided tour. Missing containers are skipped. */
export const DEMO_TOUR = [
  { number: 'PLBU4000172', label: 'home.tour.damage', target: 'container' },
  { number: 'PLBU4000043', label: 'home.tour.ghosts', target: 'open' },
  { number: 'MSCU9749070', label: 'home.tour.history', target: 'container' },
] as const;
